<template>
<v-row>
    <v-col md="3" cols="12">
        <v-card dark style="margin-top: 18px">
            <v-sheet color="blue darken-1">
                <v-card-text>
                    <v-card class="elevation-8" style="top: -18px; position: absolute;">
                        <v-sheet color="blue lighten-1">
                            <v-card-text>
                                <v-icon v-if="widget_data" size="70">euro_symbol</v-icon>
                                <v-progress-circular v-else size="70" indeterminate />
                            </v-card-text>
                        </v-sheet>
                    </v-card>
                    <div v-if="widget_data">
                        <div class="display-1 text-right">{{ widget_data.previous_month.sales }} €</div>
                        <div class="body-1 text-right">out of {{widget_data.previous_month.bookings}} bookings</div>
                    </div>
                    <div v-else>
                        <div class="display-1 text-right">0 €</div>
                        <div class="body-1 text-right">out of 0 bookings</div>
                    </div>
                </v-card-text>
                <v-divider class="mx-2" />
                <v-card-text class="subheading text-uppercase">
                    Previous Month Sales
                </v-card-text>
            </v-sheet>
        </v-card>
    </v-col>

    <v-col md="3" cols="12">
        <v-card dark style="margin-top: 18px">
            <v-sheet color="green darken-1">
                <v-card-text>
                    <v-card class="elevation-8" style="top: -18px; position: absolute;">
                        <v-sheet color="green lighten-1">
                            <v-card-text>
                                <v-icon v-if="widget_data" size="70">euro_symbol</v-icon>
                                <v-progress-circular v-else size="70" indeterminate />
                            </v-card-text>
                        </v-sheet>
                    </v-card>
                    <div v-if="widget_data">
                        <div class="display-1 text-right">{{widget_data.previous_week.sales}} €</div>
                        <div class="body-1 text-right">out of {{widget_data.previous_week.bookings}} bookings</div>
                    </div>
                    <div v-else>
                        <div class="display-1 text-right">0 €</div>
                        <div class="body-1 text-right">out of 0 bookings</div>
                    </div>
                </v-card-text>
                <v-divider class="mx-2" />
                <v-card-text class="subheading text-uppercase">
                    Previous Week Sales
                </v-card-text>
            </v-sheet>
        </v-card>
    </v-col>

    <v-col md="3" cols="12">
        <v-card dark style="margin-top: 18px">
            <v-sheet color="orange darken-1">
                <v-card-text>
                    <v-card class="elevation-8" style="top: -18px; position: absolute;">
                        <v-sheet color="orange lighten-1">
                            <v-card-text>
                                <v-icon v-if="widget_data" size="70">euro_symbol</v-icon>
                                <v-progress-circular v-else size="70" indeterminate />
                            </v-card-text>
                        </v-sheet>
                    </v-card>
                    <div v-if="widget_data">
                        <div class="display-1 text-right">{{ widget_data.yesterday.sales }} €</div>
                        <div class="body-1 text-right">out of {{widget_data.yesterday.bookings}} bookings</div>
                    </div>
                    <div v-else>
                        <div class="display-1 text-right">0 €</div>
                        <div class="body-1 text-right">out of 0 bookings</div>
                    </div>
                </v-card-text>
                <v-divider class="mx-2" />
                <v-card-text class="subheading text-uppercase">
                    Yesterday's Sales
                </v-card-text>
            </v-sheet>
        </v-card>
    </v-col>

    <v-col md="3" cols="12">
        <v-card dark style="margin-top: 18px">
            <v-sheet color="red darken-1">
                <v-card-text>
                    <v-card class="elevation-8" style="top: -18px; position: absolute;">
                        <v-sheet color="red lighten-1">
                            <v-card-text>
                                <v-icon v-if="widget_data" size="70">euro_symbol</v-icon>
                                <v-progress-circular v-else size="70" indeterminate />
                            </v-card-text>
                        </v-sheet>
                    </v-card>
                    <div v-if="widget_data">
                        <div class="display-1 text-right">{{ widget_data.today.sales }} €</div>
                        <div class="body-1 text-right">out of {{widget_data.today.bookings}} bookings</div>
                    </div>
                    <div v-else>
                        <div class="display-1 text-right">0 €</div>
                        <div class="body-1 text-right">out of 0 bookings</div>
                    </div>
                </v-card-text>
                <v-divider class="mx-2" />
                <v-card-text class="subheading text-uppercase">
                    Today's Sales
                </v-card-text>
            </v-sheet>
        </v-card>
    </v-col>

</v-row>
</template>

<script>
export default {

    props: {
        url: String
    },

    methods: {
        getWidget() {
            this.widget_data = null;
            this.$axios.get(this.url + "/sales-velocity-report")
                .then(response => {
                    this.widget_data = response.data;
                });
        }
    },

    created() {
        this.getWidget();
    },

    data() {
        return {
            widget_data: null,
            widget_headers: [
                {
                    text: 'Velocity',
                    sortable: false
                },
                {
                    text: 'Bookings',
                    align: 'right',
                    value: 'bookings'
                },
                {
                    text: 'Sales (€)',
                    align: 'right',
                    value: 'sales'
                },
                ],
        }
    }
}
</script>
